import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  ValidatorFn,
  Validators,
} from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { MatFormFieldModule } from '@angular/material/form-field'
import { LegalEntityClientService } from '../../../core/services/customer/legal-entity-client/legal-entity-client.service'
import { MatCardModule } from '@angular/material/card'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatExpansionModule } from '@angular/material/expansion'
import { MatInput } from '@angular/material/input'
import { AddressClientCreateComponent } from '../../address/address-client-create/address-client-create.component'
import { ContactClientCreateComponent } from '../../contact/contact-client-create/contact-client-create.component'
import { TaxDocumentClientCreateComponent } from '../../tax-document/tax-document-client-create/tax-document-client-create.component'
import { PaymentMethodsClientCreateComponent } from '../../payment/payment-client-create/payment-methods-client-create.component'
import { BankDetailsClientCreateComponent } from '../../bank/bank-details-client-create/bank-details-client-create.component'
import { ConsultantClientCreateComponent } from '../../person/consultant-client-create/consultant-client-create.component'
import { MatDividerModule } from '@angular/material/divider'
import { IndividualClientService } from '../../../core/services/customer/individual-client/individual-client.service'
import { NgxMaskDirective } from 'ngx-mask'
import { AssociateSubClientCreateComponent } from './associate-sub-client-create/associate-sub-client-create.component'
import { TariffClientCreateComponent } from '../../tariff/tariff-client-create/tariff-client-create.component'
import {
  MatSlideToggle,
  MatSlideToggleChange,
} from '@angular/material/slide-toggle'
import { DecimalInputDirective } from '../../../shared/directives/decimalInput'
import { CurrencyInputDirective } from '../../../shared/directives/currencyInput'
import { convertCurrency } from '../../../shared/utils/utils'
import { CommissionDividerService } from '../../../core/services/price-quote/commission-divider/commission-divider.service'
import { ResponsibleClientCreateComponent } from '../../person/responsible-client-create/responsible-client-create.component'
import { AssociateConsultantOperateCreateComponent } from '../../employee/associate-consultant-operate-create/associate-sub-client-create.component'
import { cnpjValidator } from '../../../shared/utils/cnpj_validator'
import { MatSelectModule } from '@angular/material/select'
import { cpfValidator } from '../../../shared/utils/cpf_validator'
import { NgClass } from '@angular/common'

@Component({
  selector: 'client-create',
  imports: [
    ReactiveFormsModule,
    MatButton,
    MatProgressSpinner,
    MatExpansionModule,
    MatFormFieldModule,
    MatCardModule,
    MatInput,
    MatDividerModule,
    AddressClientCreateComponent,
    ContactClientCreateComponent,
    TaxDocumentClientCreateComponent,
    PaymentMethodsClientCreateComponent,
    BankDetailsClientCreateComponent,
    ConsultantClientCreateComponent,
    NgxMaskDirective,
    AssociateSubClientCreateComponent,
    TariffClientCreateComponent,
    MatSlideToggle,
    DecimalInputDirective,
    CurrencyInputDirective,
    ResponsibleClientCreateComponent,
    AssociateConsultantOperateCreateComponent,
    MatSelectModule,
    NgClass,
  ],
  templateUrl: './client-create.component.html',
  styleUrl: './client-create.component.scss',
  providers: [
    LegalEntityClientService,
    IndividualClientService,
    CommissionDividerService,
  ],
  standalone: true,
})
export class ClientCreateComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private legalEntityClientService: LegalEntityClientService,
    private commissionDividerService: CommissionDividerService,
    private individualClientService: IndividualClientService,
    private snackbar: SnackbarCustomService,
    private dialogRef: MatDialogRef<ClientCreateComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    if (data.modal) {
      this.modal = data.modal
    }
  }

  @Output() responseCreate = new EventEmitter()
  @Output() responseModal = new EventEmitter()

  formLegalEntity: FormGroup = new FormGroup({})
  formIndividual: FormGroup = new FormGroup({})
  formFinancial: FormGroup = new FormGroup({})
  listTypeClient: any = [
    { id: 'legal', description: 'Pessoa Jurídica' },
    // { id: 'individual', description: 'Pessoa Fisica' },
  ]

  individualPerson: boolean = false

  typeClient: 'legal' | 'individual' = 'legal'

  loading: boolean = false
  modal: boolean = false

  addressList: any[] = []
  contactList: any[] = []
  taxDocumentList: any[] = []
  paymentMethodsList: any[] = []
  bankDetailsList: any[] = []
  consultantList: any[] = []
  consultantOpList: any[] = []
  tariffList: any[] = []
  subClientList: any[] = []
  responsibleList: any[] = []

  commissionDivider: any = {
    taxa: 0.0,
    divisor: 0.0,
    comissao: 0.0,
  }

  panelAdress: boolean = false
  panelContact: boolean = false
  panelResponsable: boolean = false
  panelFinancial: boolean = false
  panelBankDetails: boolean = false
  panelConsultant: boolean = false
  panelConsultantOp: boolean = false
  panelTariff: boolean = false
  panelSubClient: boolean = false

  ListPersonType: any[] = [
    { value: 'PF', description: 'Pessoa Fisica' },
    { value: 'PJ', description: 'Pessoa Jurídica' },
  ]

  ngOnInit(): void {
    this.createForm()
    this.getCommissionDivider()
  }

  close() {
    this.responseCreate.emit()
    this.dialogRef.close()
  }

  private getDocumentValidator(): ValidatorFn {
    return this.individualPerson ? cpfValidator() : cnpjValidator()
  }

  createForm(): void {
    this.formLegalEntity = this.formBuilder.group({
      personType: ['PJ', [Validators.required]],
      name: ['', [Validators.required]],
      cnpj: ['', [Validators.required, this.getDocumentValidator()]],
      // cnpj: ['', [Validators.required, cnpjValidator()]],
      corporate_name: ['', [Validators.required]],
      reg_state: [''],
      reg_municipal: [''],
    })
    this.formIndividual = this.formBuilder.group({
      name: ['', [Validators.required]],
      // cpf: [
      //   '',
      //   [Validators.required, Validators.pattern(/\d{3}\.\d{3}\.\d{3}-\d{2}/)],
      // ],
      cpf: ['', [Validators.required]],
    })
    this.formFinancial = this.formBuilder.group({
      // commission: ['', [Validators.required]],
      // divider: ['', [Validators.required]],
      tgmob: [true],
      tax: [convertCurrency(0)],
      commission: [convertCurrency(0)],
      divider: [convertCurrency(0)],
    })
  }

  getList(
    list: any[],
    typeList:
      | 'address'
      | 'contact'
      | 'tax_document'
      | 'paymentMethod'
      | 'bankDetails'
      | 'consultant'
      | 'taxDocument'
      | 'tariff'
      | 'responsible'
      | 'subClient'
      | 'associateConsultantOp',
  ): void {
    switch (typeList) {
      case 'address':
        this.addressList = list
        break
      case 'contact':
        this.contactList = list
        break
      case 'bankDetails':
        this.bankDetailsList = list
        break
      case 'consultant':
        this.consultantList = list
        break
      case 'associateConsultantOp':
        this.consultantOpList = list
        break
      case 'taxDocument':
        this.taxDocumentList = list
        break
      case 'paymentMethod':
        this.paymentMethodsList = list
        break
      case 'tariff':
        this.tariffList = list
        break
      case 'subClient':
        this.subClientList = list
        break
      case 'responsible':
        this.responsibleList = list
        break
    }
  }

  checkInvalidForm() {
    if (
      (this.typeClient == 'legal' && this.formLegalEntity.invalid) ||
      (this.typeClient == 'individual' && this.formIndividual.invalid) ||
      // this.formFinancial.invalid ||
      // this.addressList.length == 0 ||
      // this.contactList.length == 0 ||
      // this.taxDocumentList.length == 0 ||
      // this.paymentMethodsList.length == 0 ||
      // this.bankDetailsList.length == 0 ||
      // this.consultantList.length == 0
      // this.consultantOpList.length == 0 ||
      // this.tariffList.length == 0 ||
      // this.responsibleList.length == 0 ||
      // this.subClientList.length == 0
      this.loading
    ) {
      return true
    } else {
      return false
    }
  }

  createLegalModel() {
    // modelo: {
    //   isSbucliente: S || N
    //   clienteIds: [ids]
    // }
    return {
      cliente: {
        nome: this.formLegalEntity.get('name')?.value ?? '',
        razao_social: this.individualPerson
          ? 'PF'
          : (this.formLegalEntity.get('corporate_name')?.value ?? ''),
        insc_municipal: this.individualPerson
          ? ''
          : (this.formLegalEntity.get('reg_municipal')?.value ?? ''),
        insc_estadual: this.individualPerson
          ? ''
          : (this.formLegalEntity.get('reg_state')?.value ?? ''),
        cnpj: this.formLegalEntity.get('cnpj')?.value ?? '',
      },
      divisorComissao: {
        isCliente: this.formFinancial.get('tgmob')?.value ? 'N' : 'S',
        taxa: convertCurrency(this.formFinancial.get('tax')!.value),
        comissao: convertCurrency(this.formFinancial.get('commission')!.value),
        divisor: convertCurrency(this.formFinancial.get('divider')!.value),
      },
      enderecos: this.addressList.map(
        ({ tipo_endereco, idCreate, ...remainder }) => remainder,
      ),
      contatos: this.contactList.map(
        ({ tipoContato, idCreate, ...remainder }) => remainder,
      ),
      documento_fiscal: this.taxDocumentList.map(
        (ele: any) => ele.tipo_documento_id,
      ),
      forma_pagamento: this.paymentMethodsList.map(
        ({ tipo_pagamento, idCreate, ...remainder }) => remainder,
      ),
      dados_bancarios: this.bankDetailsList.map(
        ({ bancoDesc, idCreate, ...remainder }) => remainder,
      ),
      consultores: this.consultantList.map(
        ({ idCreate, ...remainder }) => remainder,
      ),
      responsaveis: this.responsibleList.map(
        ({ idCreate, ...remainder }) => remainder,
      ),
      tarifarios: this.tariffList.map(
        ({ idCreate, ...remainder }) => remainder,
      ),
      subClienteId: this.subClientList,
      consultoresOperacionais: this.consultantOpList.map((ele: any) => ele),
    }
  }

  createIndividualModel() {
    return {
      nome: this.formLegalEntity.get('name')?.value ?? '',
      cpf: this.formLegalEntity.get('cpf')?.value ?? '',
      enderecos: this.addressList,
      contatos: this.contactList,
      documento_fiscal: this.taxDocumentList,
      forma_pagamento: this.paymentMethodsList,
      dados_bancarios: this.bankDetailsList,
      consultores: this.consultantList,
      // consultoresOp: this.consultantOpList,
      // comissao: this.formFinancial.get('commission')?.value ?? '',
      // divisao: this.formFinancial.get('divider')?.value ?? '',
      // tarifarios: this.tariffList,
      // sub_clientes: this.subClientList,
      // responsaveis: this.responsiblesList,
    }
  }

  createClient() {
    this.loading = true
    if (this.typeClient == 'legal') {
      this.createClientLegal()
    } else if (this.typeClient == 'individual') {
      this.createClientIndividual()
    } else {
      this.snackbar.error('Selecione um tipo de Cliente')
    }
  }

  onChangeSelect(event: MatSlideToggleChange) {
    if (event.checked) {
      this.fillFormFinancial()
    } else {
      this.fillFormFinancial(true)
    }
  }

  fillFormFinancial(clear: boolean = false) {
    if (!clear) {
      this.formFinancial
        .get('divider')!
        .setValue(convertCurrency(this.commissionDivider.divisor))
      this.formFinancial
        .get('tax')!
        .setValue(convertCurrency(this.commissionDivider.taxa))
      this.formFinancial
        .get('commission')!
        .setValue(convertCurrency(this.commissionDivider.comissao))
      this.formFinancial.get('divider')!.disable()
      this.formFinancial.get('tax')!.disable()
      this.formFinancial.get('commission')!.disable()
    } else {
      this.formFinancial.get('divider')!.setValue(convertCurrency(0))
      this.formFinancial.get('tax')!.setValue(convertCurrency(0))
      this.formFinancial.get('commission')!.setValue(convertCurrency(0))
      this.formFinancial.get('divider')!.enable()
      this.formFinancial.get('tax')!.enable()
      this.formFinancial.get('commission')!.enable()
    }
  }

  getCommissionDivider() {
    this.commissionDividerService.getCommissionDividerDefault().subscribe({
      next: (response: ResponseRequestModel) => {
        this.commissionDivider = {
          taxa:
            response && response.data && response.data.taxa
              ? response.data.taxa
              : 0,
          divisor:
            response && response.data && response.data.divisor
              ? response.data.divisor
              : 1,
          comissao:
            response && response.data && response.data.comissao
              ? response.data.comissao
              : 0,
        }
        this.fillFormFinancial()
      },
      error: (err: ErrorRequestModel) => {
        console.error('err', err)
      },
      complete: () => {},
    })
  }

  createClientLegal() {
    let model = this.createLegalModel()
    this.legalEntityClientService.createLegalEntityClient(model).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        if (this.modal) {
          this.responseModal.emit(response)
        } else {
          this.responseCreate.emit()
        }
        this.close()
      },
      error: (err: ErrorRequestModel) => {
        let response: any = err.error
        if (response.statusCode == 439) {
          this.createClientTooSupplier(model)
        } else {
          this.loading = false
          this.snackbar.errorRequest(err)
        }
      },
      complete: () => {
        this.loading = false
        this.formLegalEntity.reset()
        this.formFinancial.reset()
      },
    })
  }

  createClientTooSupplier(model: any) {
    this.legalEntityClientService.createClientTooSupplier(model).subscribe({
      next: (response: any) => {
        this.snackbar.success(response.message)
        if (this.modal) {
          this.responseModal.emit(response)
        } else {
          this.responseCreate.emit()
        }
        this.close()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
      },
    })
  }

  personTypeChange() {
    let value = this.formLegalEntity.get('personType')?.value
    if (value == 'PF') {
      this.individualPerson = true
      this.formLegalEntity.get('cnpj')?.setValue('')
      this.formLegalEntity.get('corporate_name')?.setValue('PF')
      this.formLegalEntity.get('reg_state')?.setValue('')
      this.formLegalEntity.get('reg_municipal')?.setValue('')
    } else {
      this.individualPerson = false
      this.formLegalEntity.get('cnpj')?.setValue('')
      this.formLegalEntity.get('corporate_name')?.setValue('')
      this.formLegalEntity.get('reg_state')?.setValue('')
      this.formLegalEntity.get('reg_municipal')?.setValue('')
    }
    this.formLegalEntity
      .get('cnpj')
      ?.setValidators([Validators.required, this.getDocumentValidator()])
  }

  createClientIndividual() {
    // this.individualClientService
    //   .createIndividualClient(this.createIndividualModel())
    //   .subscribe({
    //     next: (response: ResponseRequestModel) => {
    //       this.snackbar.success(response.message)
    //       this.responseCreate.emit()
    //       this.close()
    //     },
    //     error: (err: ResponseRequestModel) => {
    //       this.loading = false
    //       this.snackbar.error(err.error)
    //     },
    //     complete: () => {
    //       this.loading = false
    //       this.formIndividual.reset()
    //       this.formFinancial.reset()
    //     },
    //   })
  }
}
